import { render, staticRenderFns } from "./SettingsStageBestOfFinal.vue?vue&type=template&id=73538d64&"
import script from "./SettingsStageBestOfFinal.vue?vue&type=script&lang=js&"
export * from "./SettingsStageBestOfFinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports